import {Routes} from "@angular/router";
import {CustomerPortalPageContentComponent} from "./customer-portal-page-content/customer-portal-page-content.component";
import {DisputeEvidenceSubmitPageComponent} from "../dispute/dispute-evidence-submit/dispute-evidence-submit-page.component";

export const CustomerPortalRoutes: Routes = [
    {
        component: CustomerPortalPageContentComponent,
        path: "dashboard"
    },
    {
        component: DisputeEvidenceSubmitPageComponent,
        path: "dispute-evidence-submit"
    },
    {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard"
    }
];
